import * as React from "react";
import FooterSection from "./FooterSection";

function Footer() {
  const productLinks = ["Overview", "Modules"];

  const moduleLinks = [
    "Authenticator",
    "Invoice",
    "Inventory & Accounting",
    "Point of Sales",
    "Loyalty"
  ];

  const companyLinks = ["About", "Contact"];

  return (
    <footer className="w-full bg-teal-500 min-h-[screen]">
      <div className="px-8 py-16 mx-auto max-w-[1200px] max-md:px-6 max-md:py-12 max-sm:px-4 max-sm:py-8">
        <div className="flex justify-between items-start max-md:flex-col max-md:gap-12">
          <div className="flex-1">
            <h1 className="mb-2 text-4xl font-bold leading-10 text-white max-sm:text-3xl max-sm:leading-9">
              kiosqu
            </h1>
            <p className="text-lg font-medium leading-7 text-white max-sm:text-base max-sm:leading-6">
              The Business OS
            </p>
          </div>

          <div className="flex gap-24 max-md:gap-12 max-md:justify-between max-md:w-full max-sm:flex-col max-sm:gap-8">
            <FooterSection title="Product" links={productLinks} />
            <FooterSection title="Modules" links={moduleLinks} />
            <FooterSection title="Company" links={companyLinks} />
          </div>
        </div>

        <div className="pt-8 mt-24 border-t border-white border-[opacitypx] max-md:mt-16 max-sm:mt-12">
          <p className="text-sm leading-5 text-white opacity-80">
            © 2026 kiosqu. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
